import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqRemoveParticipant');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'chat_rooms',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['channelId'],
    },
    'participants',
    {
      type: 'payload',
      selector: ['memberId'],
    },
  ],
});

const reqReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { type } = action;
  const defaultState = reqReducer(state, action);

  switch (type) {
    case consts.SEND:
      return {
        ...defaultState,
        removedMemberId: action.payload.memberId,
      };
    default:
      return defaultState;
  }
};



// WEBPACK FOOTER //
// ./src/redux/board/reqRemoveParticipant.js